import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@/core/api'
import { logger } from '@/utils/logger'

export type Repository = {
  id: string
  full_name: string
  name: string
  owner: string
  provider: string
  private?: boolean
  default_branch?: string
  [key: string]: unknown
}

export const useRepositoriesStore = defineStore('repositories', () => {
  const repositories = ref<Repository[]>([])
  const availableRepositories = ref<Repository[]>([])
  const loading = ref(false)

  async function fetchRepositories(projectId: string) {
    loading.value = true
    try {
      const data = (await api.getProjectRepositories(projectId)) as unknown as Repository[]
      repositories.value = data
      return data
    } catch (error) {
      logger.error('ReposStore', 'Failed to fetch repositories:', error)
      throw error
    } finally {
      loading.value = false
    }
  }

  async function fetchAvailableRepositories() {
    loading.value = true
    try {
      const data = (await api.getAvailableRepositories()) as unknown as Repository[]
      availableRepositories.value = data
      return data
    } catch (error) {
      logger.error('ReposStore', 'Failed to fetch available repositories:', error)
      throw error
    } finally {
      loading.value = false
    }
  }

  async function updateProjectRepositories(projectId: string, repos: unknown[]) {
    const data = (await api.updateProjectRepositories(projectId, repos as { provider: string; fullName: string }[])) as unknown as Repository[]
    repositories.value = data
    return data
  }

  function $reset() {
    repositories.value = []
    availableRepositories.value = []
    loading.value = false
  }

  return {
    repositories,
    availableRepositories,
    loading,
    fetchRepositories,
    fetchAvailableRepositories,
    updateProjectRepositories,
    $reset,
  }
})
